import {CHESTS} from '../constants/chests';
import {LEAGUES} from '../constants/leagues';

/**
 * Таблицы наград за рейтинговый матч. По ним считает сервер
 * (server/utils/rating/calculateChestRewards, calculateNumensRewards) и
 * объясняет игроку клиент (экран настройки поиска рейтингового матча), поэтому
 * текст для игрока не разойдется с начислением.
 *
 * Лига МАТЧА — по среднему рейтингу всех участников (явные боты идут
 * подставным рейтингом своей лиги, см. getVisibleRankedBotRating).
 */

// Сундук лиги рейтинговой партии и сундук ступенью ниже — за места пониже.
// Сундук нужен КАЖДОЙ лиге из configs/leagues: без него игроки новой лиги
// остались бы без сундуков (см. тест полноты)
export const LEAGUE_TO_CHEST = {
  [LEAGUES.BRONZE]: CHESTS.BRONZE,
  [LEAGUES.SILVER]: CHESTS.SILVER,
  [LEAGUES.GOLD]: CHESTS.GOLD,
  [LEAGUES.DIAMOND]: CHESTS.DIAMOND,
  [LEAGUES.RUBY]: CHESTS.RUBY,
  [LEAGUES.GOD]: CHESTS.GOD,
};

export const LOWER_LEAGUE_CHEST = {
  [LEAGUES.BRONZE]: CHESTS.WOODEN,
  [LEAGUES.SILVER]: CHESTS.BRONZE,
  [LEAGUES.GOLD]: CHESTS.SILVER,
  [LEAGUES.DIAMOND]: CHESTS.GOLD,
  [LEAGUES.RUBY]: CHESTS.DIAMOND,
  [LEAGUES.GOD]: CHESTS.RUBY,
};

// Число игроков рейтингового матча, для которых расписаны сундуки по местам;
// шесть и больше считаются как шесть
export const RANKED_CHEST_PLAYER_COUNTS = [2, 3, 4, 5, 6];

/**
 * Сундуки за место в рейтинговом матче: currentChest — сундук лиги матча,
 * previousChest — ступенью ниже. Пустой массив — место без сундука.
 *
 * @param {number} place - место с учетом ничьих (худшее место группы)
 * @param {number} playerCount - число игроков матча
 * @param {string} currentChest
 * @param {string} previousChest
 * @returns {string[]}
 */
export function getRankedChestsByPlace(place, playerCount, currentChest, previousChest) {
  if (playerCount === 2) {
    if (place === 1) return [currentChest];
    return [];
  }

  if (playerCount === 3) {
    if (place === 1) return [currentChest, previousChest];
    if (place === 2) return [previousChest];
    return [];
  }

  if (playerCount === 4) {
    if (place === 1) return [currentChest, currentChest];
    if (place === 2) return [currentChest];
    if (place === 3) return [previousChest];
    return [];
  }

  if (playerCount === 5) {
    if (place === 1) return [currentChest, currentChest, previousChest];
    if (place === 2) return [currentChest, previousChest];
    if (place === 3) return [currentChest];
    if (place === 4) return [previousChest];
    return [];
  }

  // 6 and more players
  if (place === 1) return [currentChest, currentChest, currentChest];
  if (place === 2) return [currentChest, currentChest];
  if (place === 3) return [currentChest, previousChest];
  if (place === 4) return [currentChest];
  if (place === 5) return [previousChest];
  return [];
}

// Множитель нуменов за рейтинговую партию по лиге среднего рейтинга. Лига
// без множителя считалась бы как бронза (×1) — поэтому он есть у КАЖДОЙ лиги
// из configs/leagues (см. тест полноты)
export const LEAGUE_NUMENS_MULTIPLIERS = {
  [LEAGUES.BRONZE]: 1,
  [LEAGUES.SILVER]: 2,
  [LEAGUES.GOLD]: 3,
  [LEAGUES.DIAMOND]: 5,
  [LEAGUES.RUBY]: 10,
  [LEAGUES.GOD]: 20,
};

// Множитель нуменов рейтинговой партии относительно обычной — поверх
// множителя лиги
export const RANKED_NUMENS_MULTIPLIER = 5;

// Нумены за место без множителей: последнему — база, остальным — база плюс
// прибавка за каждого игрока ниже по месту
export const NUMENS_BASE_REWARD = 10;
export const NUMENS_REWARD_PER_PLAYER_BELOW = 10;

// Предел прибавки за очки победы: награда растет до (1 + этот предел) раз,
// когда очков у игрока вдвое больше, чем у всех соперников вместе
export const NUMENS_WIN_POINTS_RATIO_LIMIT = 2;
